import { useEffect, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTeams } from '../../contexts/TeamsContext';
import { OnboardingStatusEnum } from 'api-client';

export const OnboardingGuard = ({ children }: { children?: ReactNode }) => {
  const { currentTeam, isLoading } = useTeams();
  const navigate = useNavigate();

  useEffect(() => {
    // Don't redirect while teams are loading
    if (isLoading) {
      return;
    }

    // If no team exists, redirect to dashboard
    if (!currentTeam) {
      navigate('/', { replace: true });
      return;
    }

    // If onboarding is already completed, redirect to dashboard
    if (currentTeam.onboardingStatus === OnboardingStatusEnum.Completed) {
      navigate('/', { replace: true });
    }
  }, [currentTeam, isLoading, navigate]);

  // Show nothing while loading or if conditions aren't met
  if (isLoading || !currentTeam || currentTeam.onboardingStatus === OnboardingStatusEnum.Completed) {
    return null;
  }

  return (
    <>
      {children}
    </>);
};

export default OnboardingGuard;
